<div class="container">
  <div class="modal fade" #myModel tabindex="-1" role="dialog" aria-hidden="true" style="top:17rem; margin-left: 2rem;"
    aria-labelledby="mySmallModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content text-left" style="width: 85%;">
        <div class="modal-header">
          <h6 class="float-left"><b>We noticed you are on mobile device</b></h6>
          <button type="button" class="close" data-dismiss="modal" (click)="resetvalues()"
            #closeVesselsModal>&times;</button>
          <!-- <h4 class="modal-title">Modal Header</h4> -->
        </div>
        <div class="modal-body">
          <div class="col-sm-12">
            <div class="row">
              <div>
                We're working on our mobile experience.For optimal use,we recommend using ENL Solutions on Desktop for
                now.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-container *ngIf="isOpenSearchCallCompleted">


  <app-voyage-filter-controls [title]="'Route Finder'" (onSubmit)="onSearch()" [filterType]="'LandingPageSearch'"
    [background]="'backgroundVoyageFinder.jpg'" [selectedValues]="selectedOpenSearch" [isOpenSearch]="isOpenSearch" [isDefaultValues]="isDefaultValues"
    [isFinder]="true"
    [pageTitle]="'Find RoRo & PCTC shipping line schedules & rates with Route Finder | ENL Solutions'">
  </app-voyage-filter-controls>

  <p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000" rejectButtonStyleClass="p-button-text" #cd>
    <p-footer>
      <button type="button" *ngIf="!isBasicPlanOver" pButton label="Search" (click)="cd.reject()"></button>
      <button type="button" pButton label="Upgrade" (click)="cd.accept()"></button>
    </p-footer>
  </p-confirmDialog>
  <!-- section for Route Finder below section -->
  <section class="mid-content voyage-finder-content">
    <h1 class="head-text">How Route Finder works</h1>
    <p>Route Finder is a one-of-a-kind tool that helps find currently available RoRo and PCTC
      shipping lines. With Route Finder, you can get an overview of ships’ departure and arrival schedules, ports as
      well
      as request a pricing quote. It helps freight forwarders, resellers, auction houses, and individual shippers to
      identify the right shipping line to transport goods from one place to another.</p>

    <p>If you want to ship your car, bike, or heavy machinery, Route Finder could be the perfect solution for you. Here
      are the steps to use the tool:</p>

    <ul>
      <li>Visit the Route Finder page.</li>
      <li>Sign in to your account or register if you are a new user.</li>
      <li>On the page, type and select the origin country and port. Repeat the same for the destination.</li>
      <li>Select the date of shipping.</li>
      <li>Click ‘Submit’ to get the available shipping options from the ports you have selected.</li>
    </ul>
    <p>You can click on ‘Rate Request’ to request a pricing quote from the shipping lines and ‘Details’ to get more
      information for each result.</p>
  </section>

</ng-container>
